import styled from 'styled-components';

import {
  device,
  doublePadding,
  hexToRGB,
  padding,
  ScreenSize,
} from '@/styles/helpers';

interface PromotionContentTitleProps {
  sub?: boolean;
}

export const ScPromotion = styled.div`
  width: 100%;
  height: 400px;
  position: relative;

  background-color: ${({ theme }) => theme.blackColor};

  & > .slider-bg {
    object-fit: cover;
  }

  & > div {
    height: 100%;
    position: relative;
    display: flex;
    align-items: center;

    .characters {
      position: absolute;
      right: 0;
      bottom: 0;
      width: 100%;
      height: 100%;
      max-height: calc(100% - 72px);

      & > img {
        object-fit: contain;
        object-position: right;
      }
    }
  }

  @media (${device.mobile}) {
    height: 382px;
    background: linear-gradient(
      180deg,
      rgba(0, 0, 0, 0.88) 0%,
      rgba(0, 0, 0, 0) 100%
    );
    background-position: center;
    background-size: cover;
    background-repeat: no-repeat;
    padding-top: 0;

    & > div {
      flex-direction: column;
      justify-content: center;
      padding-top: 24px;

      @media (${device.mobile}) {
        padding: 24px 16px 0 16px;
      }

      .characters {
        position: relative;
        order: 1;
        max-width: 180px;
        max-height: 84px;

        & > img {
          object-position: center;
        }
      }
    }
  }
`;

export const ScPromotionContentContainer = styled.div`
  max-width: ${ScreenSize.DESKTOP_L + doublePadding}px;
  width: 100%;
  padding: 0 ${padding}px;
  margin: 0 auto;

  @media (${device.desktop}) {
    max-width: ${ScreenSize.DESKTOP + doublePadding}px;
    padding: 0 ${padding}px;
  }

  @media (${device.tablet}) {
    max-width: ${ScreenSize.TABLET + doublePadding}px;
  }

  @media (${device.mobile}) {
    width: 100%;
    padding: 0 16px;
  }
`;

export const ScPromotionContent = styled.div`
  width: 100%;
  height: 256px;
  max-width: 544px;
  padding: 16px 24px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: space-between;
  background: ${({ theme }) => hexToRGB(theme.blackColor, 0.8)};
  border-radius: 24px;
  margin: 72px 0 24px;
  z-index: 3;

  @media (${device.desktop}) {
    max-width: 352px;
    padding: 16px;
  }

  @media (${device.mobile}) {
    padding: 16px;
    transform: none;
    position: static;
    order: 2;
    margin: 0;
    height: 182px;
    gap: 16px;
    width: 100%;
    max-width: none;
  }
`;

export const ScPromotionContentTitle = styled.div<PromotionContentTitleProps>`
  font-weight: 700;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme, sub }) => (sub ? theme.mainColor : theme.secondaryColor)};
  letter-spacing: 0.01em;
  text-transform: uppercase;
  text-align: center;
  max-width: 90%;

  @media (${device.mobile}) {
    font-size: 14px;
    line-height: 18px;
    letter-spacing: 0.14px;
  }
`;

export const ScPromotionContentCenter = styled.div`
  text-transform: uppercase;
  font-weight: 700;
  font-size: 28px;
  line-height: 36px;
  letter-spacing: 0.03em;
  text-align: center;
  max-width: 320px;
  overflow: hidden;
  display: flex;
  align-items: center;

  .description {
    text-overflow: ellipsis;
    display: -webkit-box;
    -webkit-line-clamp: 3;
    -webkit-box-orient: vertical;
  }

  @media (${device.desktop}) {
    font-size: 22px;
    line-height: 28px;
    letter-spacing: 0.02em;
  }

  @media (${device.mobile}) {
    line-height: 26px;
    font-size: 16px;
    line-height: 20px;
    height: 60px;
    max-width: 312px;

    &.big-fs {
      font-size: 20px;
      line-height: 26px;
    }
  }
`;

export const ScPromotionContentBottom = styled.div`
  display: flex;
  justify-content: center;
  width: 100%;

  .button {
    width: 280px;
  }

  @media (max-width: 544px) {
    .button {
      width: 100%;
      max-width: none;
    }
  }
`;
